<template>
  <v-combobox
    :value="selectedItem"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :loading="loading"
    :items="items"
    :search-input.sync="search"
    hide-no-data
    item-value="id"
    :item-text="render"
    clearable
    return-object
    no-filter
    ref="combobox"
    v-if="reload"
  >
    <template v-slot:selection="{ item }">
      <slot name="selectedItemDescription" :item="item">
        {{ render(item) }}
      </slot>
    </template>

    <template v-slot:item="{ item, attrs, on }">
      <slot name="itemDescription" :attrs="attrs" :on="on" :item="item">{{ render(item) }}</slot>
    </template>

    <template v-slot:append-item>
      <v-list-item disabled v-if="showBottomMessage">
        <v-list-item-content>
          <v-list-item-title>
            Type to filter more records...
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item></template
    >
  </v-combobox>
</template>

<script>
import ApiService from "../../services/api.service";

export default {
  name: "ParticipantField",
  props: {
    value: [Object, String],
    preventIds: Array,
    typeKey: String,
    showKey: {
      type: Boolean,
      default: false,
      required: false
    },
    showParticipantType: {
      type: Boolean,
      default: false,
      required: false
    },
    organization: {
      type: Object,
      default: null
    },
    participantType: {
      type: [Object, Array],
      default: null
    },
    showLegacyParticipantKey: {
      type: Boolean,
      default: false,
      required: false
    },
    status: { type: String, required: false }
  },
  data: () => ({
    showBottomMessage: true,
    selectedItem: {},
    loading: false,
    search: null,
    items: [],
    rules: [
      v => {
        if (!!v && !v.id) {
          return "Invalid selection";
        } else {
          return true;
        }
      }
    ],
    reload: true
  }),
  methods: {
    render(item) {
      let returnValue = "";
      if (item) {
        if (this.showLegacyParticipantKey && item) {
          returnValue += item.fullName ? item.fullName : "";
          if (this.showKey) {
            returnValue += " - " + item.participantKey ?? "";
          }
          if (item.legacyParticipantKey) returnValue += " - " + item.legacyParticipantKey ?? "";
        } else {
          if (this.showKey) {
            returnValue += item.participantKey ? item.participantKey + " - " : "";
          }
          returnValue += item.fullName ? item.fullName : "";
          if (this.showParticipantType && item && item.participantType) {
            returnValue += " - " + item.participantType.name;
          }
        }
      }
      return returnValue;
    },
    onInput(obj) {
      if (obj && obj.id) {
        this.$emit("input", obj);
      }
    },
    clear() {
      this.reload = false;
      this.$nextTick(() => {
        this.reload = true;
      });
    }
  },
  watch: {
    value(val) {
      this.selectedItem = val;
    },
    search(val) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      let filters = {};
      filters.keyword = val;
      filters.isEffective = this.status;

      if (this.organization && this.organization.id) {
        filters.organization = { id: this.organization.id };
      }
      if (this.participantType) {
        if (Array.isArray(this.participantType)) {
          filters.participantTypes = this.participantType
            .map(item => {
              if (item.id) {
                return { id: item.id };
              } else if (item.participantTypeKey) {
                return { participantTypeKey: item.participantTypeKey };
              }
              return null;
            })
            .filter(Boolean);
        } else if (this.participantType.id) {
          filters.participantType = { id: this.participantType.id };
        } else if (this.participantType.participantTypeKey) {
          filters.participantTypeKey = this.participantType.participantTypeKey;
        }
      }
      ApiService.post("/api/participants/search", filters).then(({ data }) => {
        let fullItems = data.content;
        if (this.preventIds && this.preventIds.length > 0) {
          fullItems = fullItems.reduce((acc, cur) => {
            if (this.preventIds.indexOf(cur.id) == -1) {
              acc.push(cur);
            }
            return acc;
          }, []);
        }
        if (fullItems.length > 9) {
          this.items = fullItems.slice(0, 9);
          this.showBottomMessage = true;
        } else {
          this.items = fullItems;
          this.showBottomMessage = false;
        }
        this.loading = false;
      });
    }
  },
  mounted() {
    this.clear();
    this.selectedItem = this.value;
    this.search = "";
  }
};
</script>
